module.exports = __webpack_public_path__ + "static/media/yusuf-2.7b1b4cbb.jpg";